import { useEffect, useState } from "react";
import { ServiceResponse } from "../../../app/services/shared/interfaces";
import { toast } from "react-toastify";
import { formatMoney } from "../../../utils/utils";
import useCheckingAccountService from "../../../app/services/hooks/useCheckingAccount";
import { CheckingAccountFilters } from "../../../app/models/CheckingAccount";
import WorkerFundsDataTable from "./tables/WorkerFundDataTable";



interface Props {
    checkingAccountsFilter: CheckingAccountFilters,
    setCheckingAccountsFilter: (fundsFilter: CheckingAccountFilters) => void
    setCheckingAccountTotal: (total: number) => void;
    checkingAccountTotal: number
}

const CheckingAccountContainer = ({ 
    checkingAccountsFilter,
    setCheckingAccountsFilter,
    setCheckingAccountTotal,
    checkingAccountTotal
}: Props) => {

    const { getCheckingAccountTotalByWorker, 
        getCheckingAccountsByWorker,
        fetchingGetCheckingAccountTotalByWorker,
        fetchingGetCheckingAccountsByWorker } = useCheckingAccountService();

    const [fundRequests, setFundRequests] = useState<any[]>([]);
    const [fundRequestRows, setFundRequestRows] = useState(0);
    const [showDataTable, setShowDataTable] = useState<boolean>(false);


    useEffect(()=>{
        getCheckingAccountTotalByWorker(checkingAccountsFilter, {
            onSuccess: (response: ServiceResponse) => {
                setCheckingAccountTotal(response.data.totals)
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        })
    },[checkingAccountsFilter]);

    useEffect(()=>{
        if(showDataTable){
            getCheckingAccountsByWorker(checkingAccountsFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setFundRequestRows(response.data.total_rows)
                    setFundRequests(response.data.checking_accounts)
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }
    },[checkingAccountsFilter, showDataTable, checkingAccountsFilter.page, checkingAccountsFilter.per_page]);

    const showFundRequestTable = () => {
        setShowDataTable(!showDataTable)
    }



    return (
        <>
           {/* <div className="row justify-content-start"> */}
            
                {/* FONDOS POR RENDIR*/}
                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#C2AAAA',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showFundRequestTable}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium" style={{ userSelect: 'none' }}>Fondos por rendir</p>
                                {fetchingGetCheckingAccountTotalByWorker ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(checkingAccountTotal)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {showDataTable &&                
                    <div className="col-lg-10 mb-4">
                        <div className="h5">Detalle Fondos por Rendir</div>
                        <WorkerFundsDataTable 
                            data={fundRequests}
                            progressPending={fetchingGetCheckingAccountsByWorker}
                            totalRows={fundRequestRows}
                            filter={checkingAccountsFilter}
                            setFilter={setCheckingAccountsFilter}
                        />
                    </div>
                }

           {/* </div> */}
        </>
    )

}

export default CheckingAccountContainer;